<template>
  <div class="page-container">
  <div class="banner"></div>
    <!-- 内容层（浮在背景之上） -->

    <div class="content-layer">
      <div class="center-content">
      <div class="productName" v-if="detail">{{ detail.productName }}</div>
      <div class="productImg" v-if="detail && detail.productImage">
        <img :src="detail.productImage" alt="商品图片" />
      </div>

      <div class="productCode" v-if="detail"> {{ code }}</div>
      <div class="productSpecs" v-if="detail">规格参数</div>

      <div class="oneline" v-if="detail"></div>


    <!-- 加载中 -->
    <div v-if="loading" class="loading">
      <van-loading type="spinner" vertical>加载中...</van-loading>
    </div>

    <!-- 详情内容 -->
    <div v-else-if="detail" >
      <!-- 商品规格参数 - 可展开/收起 -->
       <div class="specs-level">等级: {{ detail.level }}</div>
       <div class="specs-width">拍面: {{ detail.racketFace }}</div>
       <div class="specs-handleCircumference">内芯: {{ detail.innerCore }}</div>

       <div class="specs-racketFace">球拍长度: {{ detail.length }}</div>
       <div class="specs-length">球拍宽度: {{ detail.width }}</div>
       <div class="specs-handleLength">核心厚度: {{ detail.coreThickness }}</div>

       <div class="specs-innerCore">手柄周长: {{ detail.handleCircumference }}</div>
       <div class="specs-coreThickness">手柄长度: {{ detail.handleLength }}</div>
       <div class="specs-weight">球拍重量: {{ detail.weight }}</div>

    </div>

    <!-- 加载失败 -->
    <div v-else class="error">
      <div class="error-icon">
        <span class="iconfont icon-guanbi" style="color: #ed4014"></span>
      </div>
      <div class="error-text">{{ errorMsg || "获取详情失败" }}</div>
    </div>
   <div class="twoline"></div>
   <div class="login" @click="goLogin">
      <span v-if="!isLogin">登录/注册会员</span>
      <span v-else>前往个人中心</span>
   </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getProductTraceabilityInfo } from "@api/code";
import cookie from "@utils/store/cookie";
import $store from "@/store";

export default {
  name: "ProductTraceability",
  data() {
    return {
      loading: true,
      detail: null,
      code: "",
      errorMsg: "",
      showSpecs: true,
    };
  },
  computed: {
    isLogin() {
      return !!$store.state.app.token;
    },
  },
  mounted() {
    this.id = this.$route.params.id;
    this.code = this.$route.query.code || "";
    this.fetchDetail();
  },
  methods: {
    fetchDetail() {
      this.loading = true;
      getProductTraceabilityInfo(this.id)
        .then((res) => {
          this.loading = false;
          this.detail = res.data || res;
        })
        .catch((err) => {
          this.loading = false;
          this.errorMsg = err.msg || "获取详情失败";
        });
    },
    goBack() {
      this.$router.back();
    },
    toggleSpecs() {
      this.showSpecs = !this.showSpecs;
    },
    goLogin() {
      if (this.isLogin) {
        // 已登录，跳转到个人中心
        this.goUser();
      } else {
        // 未登录，将溯源码存入cookie，登录成功后回填到兑换框
        cookie.set("traceability_code", this.code);
        this.$router.push({ name: "Login" });
      }
    },
    goUser() {
      // 已登录，将溯源码存入cookie并跳转到个人中心
      cookie.set("traceability_code", this.code);
      this.$router.push({ name: "User" }).catch((err) => {
        // token 过期等错误时跳转到登录页
        if (err && err.msg) {
          this.$dialog.error(err.msg);
        }
        cookie.set("traceability_code", this.code);
        this.$router.push({ name: "Login" });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/* ===== 容器：占满视口 ===== */
.page-container {
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
}

/* ===== 内容层：相对定位，在背景之上 ===== */
.content-layer {
  position: relative;
  width: 100%;
  min-height: 100vh;
  z-index: 1;
  aspect-ratio: 490 / 942;
  margin: 0 auto;
}

/* ===== 居中内容容器 ===== */
.center-content {
  position: relative;
  width: 100%;
  height: 100%;
  font-family: "HarmonyOS Sans SC", "阿里巴巴普惠体", "Alibaba PuHuiTi", -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: calc(12 / 490 * 100vw);
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 14.06px;
  color: rgba(255, 255, 255, 1);
}

/* ===== Banner：靠左 ===== */
.banner {
  position: absolute;
  left: calc(50 / 490 * 100vw);
  top: calc(42 / 490 * 100vw);
  width: calc(121 / 490 * 100vw);
  height: calc(37 / 490 * 100vw);
  background: url('../../assets/images/white-banner.png') no-repeat center center;
  background-size: 100% 100%;
}

/* ===== 商品名称 ===== */
.productName {
  position: absolute;
  left: calc(50 / 490 * 100vw);
  top: calc(103 / 490 * 100vw);
  width: calc(390 / 490 * 100vw);
  height: calc(31 / 490 * 100vw);
  font-size: calc(30 / 490 * 100vw);
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 35.16px;
  color: rgba(207, 181, 159, 1);
  text-align: left;
  vertical-align: top;
  z-index: 2;
}

/* ===== 商品图片 ===== */
.productImg {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: calc(173 / 490 * 100vw);
  width: calc(173 / 490 * 100vw);
  height: calc(346 / 490 * 100vw);
  z-index: 2;
}

.productImg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* ===== 商品编码 ===== */
.productCode {
  position: absolute;
  left: calc(50 / 490 * 100vw);
  top: calc(546 / 490 * 100vw);
  width: calc(390 / 490 * 100vw);
  height: calc(16 / 490 * 100vw);
  font-size: calc(14 / 490 * 100vw);
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 16.41px;
  color: rgba(255, 255, 255, 1);
  text-align: left;
  vertical-align: top;
  z-index: 2;
}

/* ===== 规格参数标题 ===== */
.productSpecs {
  position: absolute;
  left: calc(50 / 490 * 100vw);
  top: calc(574 / 490 * 100vw);
  width: calc(209 / 490 * 100vw);
  height: calc(22 / 490 * 100vw);
  font-size: calc(20 / 490 * 100vw);
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 23.44px;
  color: rgba(255, 255, 255, 1);
  text-align: left;
  vertical-align: top;
  z-index: 2;
}

/* ===== 展开/收起图标 ===== */

/* ===== 分隔线 ===== */
.oneline {
  position: absolute;
  left: calc(50 / 490 * 100vw);
  top: calc(614 / 490 * 100vw);
  width: calc(390 / 490 * 100vw);
  height: 0;
  border: 0.5px solid rgba(171, 171, 171, 1);
  z-index: 2;
}

/* ===== 规格内容 ===== */


/* ===== 规格标签（等级及值） ===== */
.specs-label {
  font-size: calc(12 / 490 * 100vw);
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 14.06px;
  color: rgba(255, 255, 255, 1);
  text-align: left;
  vertical-align: top;
}

/* ===== 规格行：3列平分，每列130px ===== */

/* ===== 第1列 ===== */
.specs-level {
  position: absolute;
  left: calc(50 / 490 * 100vw);
  top: calc(637 / 490 * 100vw);
  width: calc(130 / 490 * 100vw);
  font-size: calc(12 / 490 * 100vw);
  font-weight: 500;
  line-height: 14.06px;
  color: rgba(255, 255, 255, 1);
  z-index: 2;
}
.specs-racketFace {
  position: absolute;
  left: calc(50 / 490 * 100vw);
  top: calc(674 / 490 * 100vw);
  width: calc(130 / 490 * 100vw);
  font-size: calc(12 / 490 * 100vw);
  font-weight: 500;
  line-height: 14.06px;
  color: rgba(255, 255, 255, 1);
  z-index: 2;
}
.specs-innerCore {
  position: absolute;
  left: calc(50 / 490 * 100vw);
  top: calc(711 / 490 * 100vw);
  width: calc(130 / 490 * 100vw);
  font-size: calc(12 / 490 * 100vw);
  font-weight: 500;
  line-height: 14.06px;
  color: rgba(255, 255, 255, 1);
  z-index: 2;
}

/* ===== 第2列：拍面 / 球拍宽度 / 手柄长度（居中偏左，标签左对齐） ===== */
.specs-width {
  position: absolute;
  left: calc(260 / 490 * 100vw);
  transform: translateX(-50%);
  top: calc(637 / 490 * 100vw);
  width: calc(130 / 490 * 100vw);
  font-size: calc(12 / 490 * 100vw);
  font-weight: 500;
  line-height: 14.06px;
  color: rgba(255, 255, 255, 1);
  text-align: left;
  z-index: 2;
}
.specs-length {
  position: absolute;
  left: calc(260 / 490 * 100vw);
  transform: translateX(-50%);
  top: calc(674 / 490 * 100vw);
  width: calc(130 / 490 * 100vw);
  font-size: calc(12 / 490 * 100vw);
  font-weight: 500;
  line-height: 14.06px;
  color: rgba(255, 255, 255, 1);
  text-align: left;
  z-index: 2;
}
.specs-coreThickness {
  position: absolute;
  left: calc(260 / 490 * 100vw);
  transform: translateX(-50%);
  top: calc(711 / 490 * 100vw);
  width: calc(130 / 490 * 100vw);
  font-size: calc(12 / 490 * 100vw);
  font-weight: 500;
  line-height: 14.06px;
  color: rgba(255, 255, 255, 1);
  text-align: left;
  z-index: 2;
}

/* ===== 第3列：内芯 / 核心厚度 / 球拍重量（靠右，标签左对齐） ===== */
.specs-handleCircumference {
  position: absolute;
  left: calc(338 / 490 * 100vw);
  top: calc(637 / 490 * 100vw);
  font-size: calc(12 / 490 * 100vw);
  font-weight: 500;
  line-height: 14.06px;
  color: rgba(255, 255, 255, 1);
  text-align: left;
  z-index: 2;
}
.specs-handleLength {
  position: absolute;
  left: calc(338 / 490 * 100vw);
  top: calc(674 / 490 * 100vw);
  font-size: calc(12 / 490 * 100vw);
  font-weight: 500;
  line-height: 14.06px;
  color: rgba(255, 255, 255, 1);
  text-align: left;
  z-index: 2;
}
.specs-weight {
  position: absolute;
  left: calc(338 / 490 * 100vw);
  top: calc(711 / 490 * 100vw);
  font-size: calc(12 / 490 * 100vw);
  font-weight: 500;
  line-height: 14.06px;
  color: rgba(255, 255, 255, 1);
  text-align: left;
  white-space: nowrap;
  z-index: 2;
}

/* ===== 分隔线2 ===== */
.twoline {
  position: absolute;
  left: calc(50 / 490 * 100vw);
  top: calc(750 / 490 * 100vw);
  width: calc(390 / 490 * 100vw);
  height: 0;
  border: 0.5px solid rgba(171, 171, 171, 1);
  z-index: 2;
}

/* ===== 登录按钮 ===== */
.login {
  position: absolute;
  left: calc(50 / 490 * 100vw);
  top: calc(780 / 490 * 100vw);
  width: calc(390 / 490 * 100vw);
  height: calc(60 / 490 * 100vw);
  background: rgba(127, 98, 73, 1);
  z-index: 10;
  display: flex;
  align-items: center;
  border-radius: 8px;
  justify-content: center;
  cursor: pointer;
  pointer-events: auto;
}

.login span {
  font-family: "HarmonyOS Sans SC", "阿里巴巴普惠体", "Alibaba PuHuiTi", -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: calc(22 / 490 * 100vw);
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 25.78px;
  color: rgba(255, 255, 255, 1);
}

.product-traceability {
  min-height: 100vh;
  background: #f5f5f5;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 44px;
  padding: 0 15px;
  background: #fff;
  border-bottom: 1px solid #eee;
}

.header .back {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
}

.header .back .iconfont {
  font-size: 20px;
  color: #333;
}

.header .title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 6rem;
}

.content {
  padding: 15px;
}

.image {
  text-align: center;
  margin-bottom: 15px;

  img {
    width: 300px;
    height: 300px;
    border-radius: 8px;
    object-fit: cover;
  }
}

.info {
  background: #fff;
  border-radius: 8px;
  padding: 15px;
}

.info-item {
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #f5f5f5;

  &:last-child {
    border-bottom: none;
  }
}

.info-label {
  font-size: 14px;
  color: #999;
}

.info-value {
  font-size: 14px;
  color: #333;
  max-width: 60%;
  text-align: right;
  word-break: break-all;
}

.specs {
  margin-top: 10px;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
}

.specs-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  cursor: pointer;
}

.specs-title {
  font-size: 14px;
  font-weight: bold;
  color: #333;
}

.specs-header .iconfont {
  font-size: 12px;
  color: #999;
  transition: transform 0.3s;
}

.specs-content {
  padding: 0 15px 15px;
}

.specs-grid {
  display: flex;
  flex-wrap: wrap;
  background: #f8f8f8;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 10px;
}

.specs-item {
  width: 33.33%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 5px;
  box-sizing: border-box;
}

.specs-label {
  font-size: 12px;
  color: #999;
  margin-bottom: 5px;
}

.specs-value {
  font-size: 14px;
  color: #333;
  font-weight: 500;
  text-align: center;
  word-break: break-all;
}

.error {
  text-align: center;
  padding: 100px 20px;
}

.error-icon {
  margin-bottom: 20px;

  .iconfont {
    font-size: 80px;
  }
}

.error-text {
  font-size: 14px;
  color: #999;
}

.login-guide {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 15px;
  background: #fff;
  border-top: 1px solid #eee;
}

.login-guide__text {
  font-size: 14px;
  color: #666;
}

.login-guide__btn {
  width: 120px;
  height: 36px;
  background: #e93323;
  color: #fff;
  border: none;
  border-radius: 18px;
  font-size: 14px;
  cursor: pointer;
}

.login-guide__btn:active {
  background: #d32a1b;
}
</style>
